import React from 'react';
const DashboardIcon: React.FC<{ size?: number; color?: string }> = ({ size = 18, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="2" width="7" height="7" rx="1.2" stroke={color} strokeWidth="1.7" />
    <rect x="11" y="2" width="7" height="7" rx="1.2" stroke={color} strokeWidth="1.7" />
    <rect x="2" y="11" width="7" height="7" rx="1.2" stroke={color} strokeWidth="1.7" />
    <rect x="11" y="11" width="7" height="7" rx="1.2" stroke={color} strokeWidth="1.7" />
  </svg>
);
export default DashboardIcon;
